import Const from '@/core/const';
const LOGIN_TYPE = Const.LOGIN_TYPE;

import Layout from '@/views/layout';
import Login from '@/views/Login';
import Home from '@/views/Home';

import OccupyOrderList from '@/views/order/occupy-order-list';
import OccupyOrderDetail from '@/views/order/occupy-order-detail';
import CharingOrderList from '@/views/order/charing-order-list';
import RechargeOrderList from '@/views/order/recharge-order-list';

const CHARGING_TYPE = Const.CHARGING.TYPE;
const RECHARGE_TYPE = Const.RECHARGE.TYPE;

const SOCKET_TYPE = Const.DEVICE.SOCKET_TYPE;

const routes = [
	{ path: '/', redirect: '/home', meta: { hidden: true } },
	{ // 登录
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {  hidden: true, title: '登录' },
	},
	{ // 重定向页面
		path: '/redirect',
		component: () => import('@/views/Redirect.vue'),
		meta: { hidden: true }
	},
	{ // 测试
		path: '/test',
		name: 'Test1',
		component: () => import('@/views/Test'),
		meta: {
			hidden: true,
			title: '测试',
			roles: [LOGIN_TYPE.ADMIN],
		},
	},
	{ // 测试2
		path: '/test2',
		name: 'Test2',
		component: () => import('@/views/Test2'),
		meta: { hidden: true }
	},
	{ // 查看监控
		path: '/camera-player',
		name: 'CameraPlayer',
		component: () => import('@/views/device/camera-player'),
		meta: { hidden: true, title: '查看监控' }
	},
	{ // 数据总览
		path: '/home',
		component: Layout,
		name: 'Home',
		meta: {
			title: '数据总览',
			icon: 'i-overview',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['home.page'],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'Home',
				component: Home,
				meta: { title: '数据总览', },
			},
		],
	},

	{ // 管理员 运营商管理
		path: '/operator',
		component: Layout,
		meta: {
			title: '运营商管理',
			icon: 'i-operator_management',
			roles: [LOGIN_TYPE.ADMIN],
			auth: ['operator.list'],
		},
		children: [
			{
				path: '',
				name: 'OperatorManagement',
				redirect: '/operator/operator-list',
				meta: { hidden: true },
			},
			{
				path: 'operator-list',
				name: 'OperatorList',
				component: () => import('@/views/operator/operator-list'),
				meta: {
					title: '运营商列表',
					roles: [LOGIN_TYPE.ADMIN],
					auth: ['operator.list'],
				},
			},
			{
				path: 'sub-operator-list',
				name: 'SubOperatorList',
				component: () => import('@/views/operator/sub-operator-list'),
				meta: {
					title: '子运营商列表',
					roles: [LOGIN_TYPE.ADMIN],
					auth: ['operator.list'],
				},
			},
			{
				path: 'operator-detail',
				name: 'OperatorDetail',
				component: () => import('@/views/operator/operator-detail'),
				meta: {
					hidden: true,
					title: '运营商详情',
					roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
					auth: ['operator.detail'],
				},
			},
			{
				path: 'operator-cdkey-list',
				name: 'OperatorCdkeyList',
				component: () => import('@/views/operator/cdkey-list'),
				meta: {
					title: '激活码列表',
					roles: [LOGIN_TYPE.ADMIN],
					auth: ['operator.list'],
				},
			},
			{
				path: 'wx-platform',
				name: 'OperatorWxPlatform',
				component: () => import('@/views/operator/wx-platform'),
				meta: {
					title: '第三方平台',
					roles: [LOGIN_TYPE.ADMIN],
				},
			},
		],
	},
	{ // 运营商 运营商管理
		path: '/operator-sp',
		component: Layout,
		meta: {
			title: '运营商管理',
			icon: 'i-operator_management',
			roles: [LOGIN_TYPE.OPERATOR],
			auth: ['operator.detail'],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'OperatorSp',
				component: () => import('@/views/operator/operator-detail'),
				meta: {
					title: '运营商详情',
				},
			},
		],
	},
	{ // 运营商 子运营商管理
		path: '/sub-account',
		component: Layout,
		meta: {
			title: '子运营商管理',
			icon: 'i-user_management',
			roles: [LOGIN_TYPE.OPERATOR],
			auth: ['operator-member.manage'],
		},
		children: [
			{
				path: '',
				name: 'SubAccountManagement',
				redirect: '/sub-account/sub-account-list',
				meta: { hidden: true },
			},
			{
				path: 'sub-account-list',
				name: 'SubAccountList',
				component: () => import('@/views/sub-account/sub-account-list'),
				meta: {
					title: '子运营商列表',
					roles: [LOGIN_TYPE.OPERATOR],
					auth: ['operator-member.manage'],
				},
			},
			{
				path: 'sub-account-detail',
				name: 'SubAccountDetail',
				component: () => import('@/views/operator/sub-operator-detail'),
				meta: {
					hidden: true,
					title: '子运营商详情',
				},
			},
			{
				path: 'sub-account-cdkey-list',
				name: 'SubAccountCdkeyList',
				component: () => import('@/views/operator/cdkey-list'),
				meta: {
					title: '激活码列表',
					roles: [LOGIN_TYPE.OPERATOR],
					auth: ['operator-member.manage'],
				},
			},
		],
	},
	{ // 片区管理
		path: '/org',
		component: Layout,
		meta: {
			title: '片区管理',
			icon: 'i-org_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['org.detail'],
		},
		children: [
			{
				path: '',
				name: 'OrgManagement',
				redirect: '/org/org-list',
				meta: { hidden: true },
			},
			{
				path: 'org-list',
				name: 'OrgList',
				component: () => import('@/views/org/org-list'),
				meta: {
					title: '片区列表',
					auth: ['org.detail'],
				},
			},
			{
				path: 'org-detail',
				name: 'OrgDetail',
				component: () => import('@/views/org/org-detail'),
				meta: { hidden: true, title: '片区详情', auth: ['org.detail'], },
			},
			{ // 片区回收站
				path: 'org-recycle-list',
				name: 'OrgRecycleList',
				component: () => import('@/views/org/org-recycle-list'),
				meta: {
					title: '片区回收站',
					roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
					auth: ['org.detail']
				},
			},
		],
	},
	{ // 充电站管理
		path: '/station',
		component: Layout,
		meta: {
			title: '充电站管理',
			icon: 'i-station_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				name: 'StationManagement',
				redirect: '/station/station-list',
				meta: { hidden: true },
			},
			{ // 充电站列表
				path: 'station-list',
				name: 'StationList',
				component: () => import('@/views/station/station-list'),
				meta: {
					title: '充电站列表',
				},
			},
			{ // 充电站回收站
				path: 'station-recycle-list',
				name: 'StationRecycleList',
				component: () => import('@/views/station/station-recycle-list'),
				meta: {
					title: '充电站回收站',
					roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
				},
			},
			{ // 充电站审核
				path: 'station-audit-list',
				name: 'StationAuditList',
				component: () => import('@/views/station/station-audit-list'),
				meta: {
					title: '充电站审核',
					auth: ['station.check'],
				},
			},
			{ // 充电站详情
				path: 'station-detail',
				name: 'StationDetail',
				component: () => import('@/views/station/station-detail'),
				meta: {
					hidden: true,
					title: '充电站详情',
					auth: ['station.check'],
				},
			},
		],
	},
	{ // 设备管理
		path: '/device',
		component: Layout,
		meta: {
			title: '设备管理',
			icon: 'i-socket_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				name: 'SocketManagement',
				redirect: '/device/socket-list',
				meta: { hidden: true },
			},
			{ // 设备管理
				path: 'socket-list',
				name: 'SocketList',
				component: () => import('@/views/device/socket-list.vue'),
				meta: { title: '设备管理', type: SOCKET_TYPE.ALL },
			},
			{ // 设备详情
				path: 'socket-detail',
				name: 'SocketDetail',
				component: () => import('@/views/device/socket-detail.vue'),
				meta: { hidden: true, title: '设备详情', },
			},
			{ // 设备列表
				path: 'device-list',
				name: 'DeviceList',
				component: () => import('@/views/device/device-list.vue'),
				meta: { title: '设备列表', },
			},

			{ // 刷蓝设备列表
				path: 'brush-blue-socket-list',
				name: 'BrushBlueSocketList',
				component: () => import('@/views/device/socket-list.vue'),
				meta: { title: '刷蓝设备列表', type: SOCKET_TYPE.BRUSH_BLUE, roles: [LOGIN_TYPE.ADMIN], },
			},

			{ // 电池管理
				path: 'battery-list',
				name: 'BatteryList',
				component: () => import('@/views/device/battery-list.vue'),
				meta: { title: '电池管理', anti_auth: ['DAHUA'], },
			},
			{ // 电池详情
				path: 'battery-detail',
				name: 'BatteryDetail',
				component: () => import('@/views/device/battery-detail.vue'),
				meta: { hidden: true, title: '电池详情', },
			},

			{ // 道闸管理 TODO
				path: 'gate-list',
				name: 'GateList',
				component: () => import('@/views/device/gate-list.vue'),
				meta: { title: '道闸管理', },
			},
			{ // 道闸详情
				path: 'gate-detail',
				name: 'GateDetail',
				component: () => import('@/views/device/gate-detail.vue'),
				meta: { hidden: true, title: '道闸详情', },
			},

			{ // 监控摄像管理
				path: 'camera-list',
				name: 'CameraList',
				component: () => import('@/views/device/camera-list.vue'),
				meta: { title: '监控摄像管理', anti_auth: ['DAHUA'], auth: ['device.camera.manage'] },
			},

			{ // 参数任务列表
				path: 'config-task-list',
				name: 'DeviceConfigTaslList',
				component: () => import('@/views/device/config-task-list.vue'),
				meta: { title: '参数任务列表', auth: ['device_task.manage'], },
			},
			{ // 参数任务详情
				path: 'config-task-detail',
				name: 'DeviceConfigTaslDetail',
				component: () => import('@/views/device/config-task-detail.vue'),
				meta: { hidden: true, title: '参数任务详情', },
			},

			{ // 场地险订单管理
				path: 'venue-insurance-list',
				name: 'OperatorVenueInsuranceList',
				component: () => import('@/views/system/venue-insurance-list.vue'),
				meta: {
					title: '场地险订单管理',
					roles: [LOGIN_TYPE.OPERATOR],
					auth: ['operator.insurance.manage.v2']
				},
			},

			{ // 设备型号管理
				path: 'model-list',
				name: 'ModelList',
				component: () => import('@/views/device/model-list.vue'),
				meta: { title: '设备型号管理', roles: [LOGIN_TYPE.ADMIN], },
			},
		],
	},

	{ // 充电订单管理
		path: '/charing-order',
		component: Layout,
		meta: {
			title: '充电订单管理',
			icon: 'i-charing_order_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['order.list'],
		},
		children: [
			{
				path: '',
				name: 'CharingOrderManagement',
				redirect: 'order-list-today',
				meta: { hidden: true, },
			},
			{
				path: 'order-list-today',
				name: 'CharingOrderListToday',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.TODAY, title: '今日订单', auth: ['order.list'], },
			},
			{
				path: 'order-list-precontract',
				name: 'CharingOrderListPrecontract',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.PRECONTRACT, title: '预约订单', auth: ['pre.config.detail'], precontract: 1 },
			},
			{
				path: 'order-list-all',
				name: 'CharingOrderListAll',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.ALL, title: '全部订单', auth: ['order.list'], },
			},
			{
				path: 'order-list-all-history',
				name: 'CharingOrderListHistory',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.ALL, title: '历史订单', auth: ['order.list'], history: 1, },
			},
			{
				path: 'order-list-charge-first-pursue',
				name: 'CharingOrderListChargeFirstPursue',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.POSTPAY_FAIL, title: '先充后付欠款订单', roles: [LOGIN_TYPE.ADMIN], auth: ['order.list'], },
			},
			{
				path: 'order-list-abnormal',
				name: 'CharingOrderListAbnormal',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.ERFUND, title: '异常订单', auth: ['order.list'], },
			},
			{
				path: 'order-list-success',
				name: 'CharingOrderListSuccess',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.SUCCESS, title: '成功订单', auth: ['order.list'], },
			},
			{
				path: 'order-list-unpay',
				name: 'CharingOrderListUnpay',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.UNPAY, title: '未支付订单', auth: ['order.list'], },
			},
			{
				path: 'order-list-refund',
				name: 'CharingOrderListRefund',
				component: CharingOrderList,
				meta: { type: CHARGING_TYPE.REFUND, title: '结算后退款订单', auth: ['order.list'], },
			},
			{
				path: 'order-detail',
				component: () => import('@/views/order/charing-order-detail'),
				name: 'CharingOrderDetail',
				meta: { hidden: true, title: '订单详情', auth: ['order.detail'], },
			},
			{
				path: 'order-export',
				component: () => import('@/views/order/charing-order-export'),
				name: 'CharingOrderExport',
				meta: { title: '订单导出列表', auth: ['order.detail'], },
			},
		],
	},
	{ // 充值订单管理
		path: '/recharge-order',
		component: Layout,
		meta: {
			title: '充值订单管理',
			icon: 'i-financial_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['recharge-order.list'],
		},
		children: [
			{
				path: '',
				name: 'RechargeOrderManagement',
				redirect: 'order-list-all',
				meta: { hidden: true, },
			},
			{
				path: 'order-list-all',
				name: 'RechargeOrderList',
				component: RechargeOrderList,
				meta: { type: RECHARGE_TYPE.ALL, title: '全部订单', auth: ['recharge-order.list'], },
			},
			{
				path: 'order-list-refund',
				name: 'RechargeOrderListUnpay',
				component: RechargeOrderList,
				meta: { type: RECHARGE_TYPE.REFUND, title: '结算后退款订单', auth: ['recharge-order.list'], },
			},
			{
				path: 'order-detail',
				name: 'RechargeOrderDetail',
				component: () => import('@/views/order/recharge-order-detail'),
				meta: { hidden: true, title: '订单详情', auth: ['recharge-order.detail'], },
			},
		],
	},
	{ // 占用费订单管理
		path: '/occupy-order',
		component: Layout,
		meta: {
			title: '占用费订单管理',
			icon: 'i-block',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['order.list'],
			anti_auth: ['DAHUA'],
		},
		children: [
			{
				path: '',
				name: 'OccupyOrderManagement',
				redirect: 'tank-order-list',
				meta: { hidden: true, },
			},
			{ // 充电柜占用订单
				path: 'tank-order-list',
				name: 'TankOccupyOrderList',
				component: OccupyOrderList,
				meta: { type: Const.OCCUPY.TYPE.TANK, title: '充电柜占用订单', auth: ['order.list'], },
			},
			{ // 充电柜占用订单详情
				path: 'tank-order-detail',
				name: 'TankOccupyOrderDetail',
				component: () => import('@/views/order/occupy-order-detail'),
				meta: { hidden: true, type: Const.OCCUPY.TYPE.TANK, title: '充电柜占用订单详情', auth: ['order.detail'], },
			},
			{ // 道闸占用订单
				path: 'gate-order-list',
				name: 'GateOccupyOrderList',
				component: OccupyOrderList,
				meta: { type: Const.OCCUPY.TYPE.GATE, title: '道闸占用订单', auth: ['order.list'], },
			},
			{ // 道闸占用订单详情
				path: 'gate-order-detail',
				name: 'GateOccupyOrderDetail',
				component: () => import('@/views/order/occupy-order-detail'),
				meta: { hidden: true, type: Const.OCCUPY.TYPE.GATE, title: '道闸占用订单详情', auth: ['order.detail'], },
			},
			{ // 汽车充占用订单
				path: 'charge-order-list',
				name: 'ChargeOccupyOrderList',
				component: OccupyOrderList,
				meta: { type: Const.OCCUPY.TYPE.CHARGE, title: '汽车充占用订单', auth: ['car-occupy.view'], },
			},
			{ // 汽车充占用订单详情
				path: 'charge-order-detail',
				name: 'ChargeOrderDetail',
				component: OccupyOrderDetail,
				meta: { hidden: true, type: Const.OCCUPY.TYPE.CHARGE, title: '汽车充占用订单详情', auth: ['car-occupy.view'], },
			},
			{ // 汽车充欠款订单
				path: 'pursue-order-list',
				name: 'PursueOrderList',
				component: () => import('@/views/order/pursue-order-list.vue'),
				// 'order.list', 
				meta: { title: '汽车充欠款订单', auth: ['car-occupy.view'], },
			},
			{ // 汽车充欠款订单详情
				path: 'pursue-order-detail',
				name: 'PursueOrderDetail',
				component: () => import('@/views/order/pursue-order-detail'),
				// 'order.detail', 
				meta: { hidden: true, type: Const.OCCUPY.TYPE.GATE, title: '汽车充欠款订单详情', auth: ['car-occupy.view'], },
			},
		],
	},
	{ // 换电柜订单管理
		path: '/cabinet',
		component: Layout,
		meta: {
			title: '换电柜订单管理',
			icon: 'i-networking',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['order.list'],
			anti_auth: ['DAHUA'],
		},
		children: [
			{
				path: '',
				name: 'CabinetOrderManagement',
				redirect: 'order-list',
				meta: { hidden: true, },
			},
			{ // 换电套餐订单
				path: 'order-list',
				name: 'CabinetOrderList',
				component: () => import('@/views/order/cabinet-order-list'),
				meta: { title: '换电套餐订单', auth: ['order.list'], },
			},
			{ // 套餐订单详情
				path: 'order-detail',
				name: 'CabinetOrderDetail',
				component: () => import('@/views/order/cabinet-order-detail'),
				meta: { hidden: true, title: '订单详情', auth: ['order.detail'], },
			},
			{ // 换电套餐列表
				path: 'package-list',
				name: 'CabinetPackageList',
				component: () => import('@/views/order/cabinet-package-list'),
				meta: { title: '换电套餐列表', },
			},
			{ // 套餐订单详情
				path: 'package-detail',
				name: 'CabinetPackageDetail',
				component: () => import('@/views/order/cabinet-package-detail'),
				meta: { hidden: true, title: '套餐详情', },
			},
			{ // 换电记录列表
				path: 'record-list',
				name: 'CabinetRecordList',
				component: () => import('@/views/order/cabinet-record-list'),
				meta: { title: '换电记录列表', },
			},
			{ // 换电记录详情
				path: 'record-detail',
				name: 'CabinetRecordDetail',
				component: () => import('@/views/order/cabinet-record-detail'),
				meta: { hidden: true, title: '换电记录详情', },
			}
		],
	},

	{ // 充电卡管理
		path: '/card',
		component: Layout,
		meta: {
			title: '充电卡管理',
			icon: 'i-charing_card_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['card.list'],
		},
		children: [
			{
				path: '',
				redirect: '/card/reality-card-list',
				name: 'CharingCardManagement',
				meta: { hidden: true, },
			},
			{ // 实体卡列表
				path: 'reality-card-list',
				name: 'RealityCardList',
				component: () => import('@/views/card/reality-card-list'),
				meta: { title: '实体卡列表', auth: ['card.list'], },
			},
			{ // 实体充电卡详情
				path: 'reality-card-detail',
				name: 'RealityCardDetail',
				component: () => import('@/views/card/reality-card-detail'),
				meta: { hidden: true, title: '实体充电卡详情', },
			},
			{ // 虚拟卡列表
				path: 'virtual-card-list',
				name: 'VirtualCardList',
				component: () => import('@/views/card/virtual-card-list'),
				meta: { title: '虚拟卡列表', auth: ['card.virtual.list'], },
			},
			{ // 已注销虚拟卡列表
				path: 'deleted-virtual-card-list',
				name: 'DeletedVirtualCardList',
				component: () => import('@/views/card/virtual-card-list'),
				meta: { title: '已注销虚拟卡', auth: ['card.virtual.list'], deleted: true, },
			},
			{ // 虚拟充电卡详情
				path: 'virtual-card-detail',
				name: 'VirtualCardDetail',
				component: () => import('@/views/card/virtual-card-detail'),
				meta: { hidden: true, title: '虚拟充电卡详情', auth: ['card.virtual.list'], },
			},
			{ // 卡片充值记录
				path: 'card-recharge-list',
				name: 'CardRechargeList',
				component: () => import('@/views/card/card-recharge-list'),
				meta: { title: '卡片充值记录', },
			},
			{ // 卡片统计报表
				path: 'card-statistical-report',
				name: 'StatisticalReport',
				component: () => import('@/views/card/statistical-report'),
				meta: { title: '卡片统计报表', auth: ['card.stat'] }
			},
			{ // 卡片充值任务
				path: 'card-recharge-task-list',
				name: 'CardRechargeTaskList',
				component: () => import('@/views/card/recharge-task-list'),
				meta: { title: '卡片充值任务', auth: ['card.recharge-task.manage'], },
			},
			{ // 充值任务详情
				path: 'card-recharge-task-detail',
				name: 'CardRechargeTaskDetail',
				component: () => import('@/views/card/recharge-task-detail'),
				meta: { hidden: true, title: '充值任务详情', auth: ['card.recharge-task.manage'], },
			},
		],
	},
	{ // 车辆管理
		path: '/car-vin',
		component: Layout,
		meta: {
			title: '车辆管理',
			icon: 'i-car',
			roles: [LOGIN_TYPE.ADMIN],  // , LOGIN_TYPE.OPERATOR
			anti_auth: ['DAHUA'],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'CarVinManagement',
				redirect: '/car-vin/car-vin-list',
				meta: { hidden: true, },
			},
			{
				path: 'car-vin-list',
				name: 'CarVinList',
				component: () => import('@/views/car-vin/car-vin-list.vue'),
				meta: { title: '车辆信息列表', },
			},
			// {
			// 	path: 'refund-detail',
			// 	name: 'RefundDetail',
			// 	component: () => import('@/views/refund/refund-detail.vue'),
			// 	meta: { hidden: true, title: '退款申请详情', },
			// },
		],
	},
	{ // 退款管理
		path: '/refund',
		component: Layout,
		meta: {
			title: '退款管理',
			icon: 'i-expenditure',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			anti_auth: ['DAHUA'],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'RefundManagement',
				redirect: '/refund/refund-list',
				meta: { hidden: true, },
			},
			{
				path: 'refund-list',
				name: 'RefundList',
				component: () => import('@/views/refund/refund-list.vue'),
				meta: { title: '退款申请列表', },
			},
			{
				path: 'refund-detail',
				name: 'RefundDetail',
				component: () => import('@/views/refund/refund-detail.vue'),
				meta: { hidden: true, title: '退款申请详情', },
			},
		],
	},
	{ // 结算管理
		path: '/settlement',
		component: Layout,
		meta: {
			title: '结算管理',
			icon: 'i-settlement_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['clearing-order.list'],
		},
		children: [
			{
				path: '',
				name: 'SettlementManagement',
				redirect: '/settlement/account-list',
				meta: { hidden: true, },
			},
			{
				path: 'admin-account-detail',
				name: 'AdminAccountDetail',
				component: () => import('@/views/settlement/admin-account-detail'),
				meta: { title: '平台账户详情', roles: [LOGIN_TYPE.ADMIN], auth: ['service.charge.view'], },
			},
			{
				path: 'account-list',
				name: 'SettlementAccountList',
				component: () => import('@/views/settlement/settlement-account-list'),
				meta: { title: '分账账户列表', auth: ['clearing-order.list'], },
			},
			{
				path: 'account-detail',
				name: 'SettlementAccountDetail',
				component: () => import('@/views/settlement/settlement-account-detail'),
				meta: { hidden: true, title: '账户余额详情', },
			},
			{
				path: 'transfer-list',
				name: 'SettlementTransferList',
				component: () => import('@/views/settlement/settlement-transfer-list'),
				meta: { title: '转账列表', auth: ['clearing-order.list'], },
			},
			{
				path: 'transfer-detail',
				name: 'SettlementTransferDetail',
				component: () => import('@/views/settlement/settlement-transfer-detail'),
				meta: { hidden: true, title: '转账详情', },
			},
			{
				path: 'statement-list',
				name: 'StatementOfAccount',
				component: () => import('@/views/settlement/settlement-statement-list'),
				meta: { title: '对账单列表', auth: ['statement.list'], },
			},
		],
	},
	{ // 服务费管理
		path: '/service-charge',
		component: Layout,
		meta: {
			title: '服务费管理',
			icon: 'i-recharge',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['ADMIN', 'SUB_DIRECTSALES', 'DISTRIBUTOR', 'DIRECTSALES'],
			anti_auth: ['HIDDEN_SERVICE'],
		},
		children: [
			{
				path: '',
				name: 'ServiceChargeManagement',
				redirect: '/service-charge/charge-list',
				meta: { hidden: true, },
			},

			{ // 账户详情 - 运营商端
				path: 'account-detail-sp',
				name: 'ServiceChargeAccountDetail',
				component: () => import('@/views/service-charge/account-detail'),
				meta: { title: '账户详情', roles: [LOGIN_TYPE.OPERATOR], auth: ['ADMIN', 'DISTRIBUTOR', 'DIRECTSALES'] },
			},
			{ // 账户列表
				path: 'account-list',
				name: 'ServiceChargeAccountList',
				component: () => import('@/views/service-charge/account-list'),
				meta: { title: '账户列表', auth: ['ADMIN', 'DISTRIBUTOR'] },
			},
			{ // 账户详情
				path: 'account-detail',
				name: 'ServiceChargeAccountDetail',
				component: () => import('@/views/service-charge/account-detail'),
				meta: { hidden: true, title: '账户详情', auth: ['ADMIN', 'DISTRIBUTOR'] },
			},

			{ // 收费模版
				path: 'package-list',
				name: 'ServiceChargePackage',
				component: () => import('@/views/service-charge/package-list'),
				meta: { title: '收费模版', roles: [LOGIN_TYPE.ADMIN /* , LOGIN_TYPE.OPERATOR */], auth: ['ADMIN' /* , 'DISTRIBUTOR' */], },
			},

			{ // 收费分组
				path: 'group-list',
				name: 'ServiceChargeGroupList',
				component: () => import('@/views/service-charge/group-list'),
				meta: { title: '收费分组', roles: [LOGIN_TYPE.ADMIN /* , LOGIN_TYPE.OPERATOR */], auth: ['ADMIN' /* , 'DISTRIBUTOR' */], },
			},
			{ // 分组详情
				path: 'group-detail',
				name: 'ServiceChargeGroupDetail',
				component: () => import('@/views/service-charge/group-detail'),
				meta: { hidden: true, title: '分组详情', roles: [LOGIN_TYPE.ADMIN /* , LOGIN_TYPE.OPERATOR */], auth: ['ADMIN' /* , 'DISTRIBUTOR' */], },
			},
			{ // 收费标准 - 运营商端
				path: 'service-detail',
				name: 'ServiceChargeGroupDetailSp',
				component: () => import('@/views/service-charge/group-detail'),
				meta: { title: '服务费账单', oldTitle: '收费标准', roles: [/* LOGIN_TYPE.ADMIN,  */ LOGIN_TYPE.OPERATOR], auth: ['DIRECTSALES', 'DISTRIBUTOR', 'SUB_DIRECTSALES'], },
			},

			{ // 设备 服务费明细
				path: 'device-detail',
				name: 'ServiceChargeDeviceDetail',
				component: () => import('@/views/service-charge/device-detail'),
				meta: { hidden: true, title: '设备服务费明细', auth: ['ADMIN', 'DISTRIBUTOR'], },
			},

			{ // 服务费统计
				path: 'service-stat',
				name: 'ServiceChargeStat',
				component: () => import('@/views/service-charge/service-stat'),
				meta: { title: '服务费统计', service_version: 1 },
			},

			{ // 服务费账单 - 仅供平台方
				path: 'bill-list',
				name: 'ServiceChargeBillList',
				component: () => import('@/views/service-charge/bill-list'),
				meta: { title: '服务费账单', roles: [LOGIN_TYPE.ADMIN], service_version: 1 },
			},

			{ // 服务费统计 - 旧版
				path: 'old-bill-list',
				name: 'ServiceChargeOldBillList',
				component: () => import('@/views/service-charge/old-bill-list'),
				meta: { title: '服务费账单', service_version: 0 },
			},

			{ // 线上支付记录 选择设备主动支付扫码支付的记录
				path: 'service-recharge-order-list',
				name: 'ServiceRechargeOrderList',
				component: () => import('@/views/service-charge/recharge-order-list'),
				meta: { title: '线上支付记录', service_version: 1 },
			},
			{ // 线上支付记录 选择设备主动支付扫码支付的记录
				path: 'service-recharge-order-detail',
				name: 'ServiceRechargeOrderList',
				component: () => import('@/views/service-charge/recharge-order-detail'),
				meta: { hidden: true, title: '线上支付详情', service_version: 1 },
			},

			{ // 服务费缴费记录
				path: 'service-order-list',
				name: 'ServiceOrderList',
				component: () => import('@/views/order/service-order-list'),
				meta: { title: '服务费缴费记录', auth: ['ADMIN', 'DISTRIBUTOR'], },
			},
			{ // 服务费缴费记录详情
				path: 'service-order-detail',
				name: 'ServiceOrderDetail',
				component: () => import('@/views/order/service-order-detail'),
				meta: { hidden: true, title: '缴费详情', roles: [LOGIN_TYPE.ADMIN], auth: ['ADMIN', 'DISTRIBUTOR'], },
			},
		],
	},
	{ // 分账账户 结算管理
		path: '/settlement-clearing-account-detail',
		component: Layout,
		meta: {
			title: '结算管理',
			icon: 'i-settlement_management',
			roles: [LOGIN_TYPE.CLEARING_ACCOUNT],
		},
		children: [
			{
				path: '',
				name: 'SettlementAccountDetailSp',
				component: () => import('@/views/settlement/settlement-account-detail'),
				meta: { hidden: true, title: '账户余额详情', },
			},
		],
	},
	{ // 集团机构管理
		path: '/team',
		component: Layout,
		meta: {
			title: '集团机构管理',
			auth: ['operator-manage.team.vin'],
			hidden: true,
			breadcrumb: false,
		},
		children: [
			{
				path: 'team-detail',
				name: 'TeamDetail',
				component: () => import('@/views/operator/team-detail'),
				meta: {
					hidden: true,
					title: '集团机构详情',
					roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
					auth: ['operator-manage.team.vin'],
				},
			},
		],
	},


	{ // 大屏统计
		path: '/statistic',
		name: 'Statistic',
		component: () => import('@/views/statistic/index'),
		meta: { hidden: true, title: '来点电运营大数据中心' },
	},
	{ // 大屏统计-地图模式
		path: '/statistic-map',
		name: 'StatisticMap',
		component: () => import('@/views/statistic/map.vue'),
		meta: { hidden: true, title: '来点电运营大数据中心-地图模式' },
	},
	{ // 统计报表
		path: '/statement',
		component: Layout,
		meta: {
			title: '统计报表',
			icon: 'i-statement',
			roles: [LOGIN_TYPE.ADMIN],
		},
		children: [
			{
				path: '',
				name: 'StatisticalStatement',
				redirect: '/statement/org-day',
				meta: { hidden: true, },
			},
			{ // 片区日报表
				path: 'org-day',
				name: 'OrgStatistical',
				component: () => import('@/views/statement/org-statistical'),
				meta: { hidden: true, title: '片区日报表', },
			},
			{ // 设备日增量
				path: 'socket-increase',
				name: 'SocketIncreaseStatistical',
				component: () => import('@/views/statement/socket-increase-statistical'),
				meta: {title: '设备日增量',roles: [LOGIN_TYPE.ADMIN],},
			},
			{ // 设备离线统计
				path: 'socket-offline',
				name: 'SocketOfflineStatistical',
				component: () => import('@/views/statement/socket-offline-statistical'),
				meta: { title: '设备离线统计', roles: [LOGIN_TYPE.ADMIN], },
			},
			{ // 直流桩充电订单统计
				path: 'dc-charge-order',
				name: 'dcChargeOrderStatistical',
				component: () => import('@/views/statement/dc-charge-order-statistical'),
				meta: { title: '直流桩充电订单统计', roles: [LOGIN_TYPE.ADMIN], },
			},
		],
	},

	{ // 监控告警
		path: '/alarm',
		component: Layout,
		meta: {
			title: '监控告警',
			icon: 'i-monitor_warning',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				name: 'AlarmManagement',
				redirect: '/alarm/device-fault',
				meta: { hidden: true, },
			},
			{
				path: 'alarm-list',
				name: 'AlarmList',
				component: () => import('@/views/alarm/alarm-list'),
				meta: { hidden: true, title: '告警列表', },
			},
			{
				path: 'alarm-detail',
				name: 'AlarmDetail',
				component: () => import('@/views/alarm/alarm-detail'),
				meta: { hidden: true, title: '告警详情', },
			},
			{ // 设备故障告警（SaaS 租户视角，仅运营商可见；平台管理员不参与该链路）
				path: 'device-fault',
				name: 'DeviceFault',
				component: () => import('@/views/device-fault/index'),
				meta: { title: '设备故障告警', roles: [LOGIN_TYPE.OPERATOR], account_auth: [LOGIN_TYPE.OPERATOR], badge: 'device_fault' },
			},
			{ // 错误日志
				path: 'error-log',
				name: 'ErrorLog',
				component: () => import('@/views/system/error-log.vue'),
				meta: { title: '错误日志', roles: [LOGIN_TYPE.ADMIN], },
			},
		],
	},
	{ // 消息管理
		path: '/message',
		component: Layout,
		meta: {
			title: '系统消息',
			icon: 'i-message',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				redirect: '/message/FAQ',
				name: 'MessageManagement',
				meta: { hidden: true, },
			},
			{
				path: 'feedback-order-list',
				name: 'FeedbackOrderList',
				component: () => import('@/views/message/feedback-order-list'),
				meta: { title: '反馈工单列表', auth: ['ticket.view'] },
			},
			{
				path: 'feedback-order-detail',
				name: 'FeedbackOrderDetail',
				component: () => import('@/views/message/feedback-order-detail'),
				meta: { hidden: true, title: '反馈工单详情', },
			},
			{
				path: 'feedback-list',
				name: 'UserFeedbackList',
				component: () => import('@/views/message/feedback-list'),
				meta: { hidden: false, title: '历史反馈', auth: ['ticket.view'], anti_auth: ['DAHUA'] },
			},
			{
				path: 'feedback-detail',
				name: 'UserFeedbackDetail',
				component: () => import('@/views/message/feedback-detail'),
				meta: { hidden: true, title: '历史反馈详情', anti_auth: ['DAHUA'] },
			},
			{
				path: 'notice-list',
				name: 'NoticeList',
				component: () => import('@/views/message/notice-list'),
				meta: { title: '系统公告', auth: ['system-notice.list'], anti_auth: ['DAHUA'] },
			},
			{
				path: 'notice-detail',
				name: 'NoticeDetail',
				component: () => import('@/views/message/notice-detail'),
				meta: { hidden: true, title: '公告详情', anti_auth: ['DAHUA'] },
			},
			{
				path: 'FAQ',
				name: 'FAQ',
				component: () => import('@/views/message/faq-list'),
				meta: { title: '常见问题', anti_auth: ['DAHUA'] },
			},
		],
	},
	// { // 系统管理
	// 	path: '/system-manage',
	// 	component: Layout,
	// 	meta: {
	// 		// hidden: true,
	// 		title: '系统管理',
	// 		icon: 'i-control',
	// 		roles: [LOGIN_TYPE.ADMIN],
	// 		is_leaf: true,
	// 	},
	// 	children: [
	// 		/** {
	// 			path: '',
	// 			redirect: '/system/advertising-setting',
	// 			name: 'SystemManagement',
	// 			meta: { hidden: true, },
	// 		},
	// 		{ // 商户配置
	// 			path: 'merchant-setting',
	// 			name: 'MerchantSetting',
	// 			component: () => import('@/views/system/merchant-setting.vue'),
	// 			meta: { hidden: true, title: '商户配置', },
	// 		}, */
	// 		{
	// 			path: '',
	// 			redirect: '/system-manage/system-detail',
	// 			name: 'SystemManagement',
	// 			meta: { hidden: true, },
	// 		},
	// 		{ // 系统详情
	// 			path: 'system-detail',
	// 			name: 'SystemDetail',
	// 			component: () => import('@/views/system/system-detail.vue'),
	// 			meta: { hidden: true, title: '系统详情', },
	// 		},
	// 	],
	// },

	{ // 广告管理
		path: '/system',
		component: Layout,
		meta: {
			title: '增值权益',
			icon: 'i-adver',
			roles: [LOGIN_TYPE.ADMIN],
		},
		children: [
			{
				path: '',
				redirect: '/system/advertising-setting',
				name: 'SystemManagement',
				meta: { hidden: true, },
			},
			{ // 广告配置
				path: 'advertising-setting',
				name: 'AdvertisingSetting',
				component: () => import('@/views/system/advertising-setting.vue'),
				meta: { title: '广告配置', },
			},
			{ // 广告规则
				path: 'advertising-rule',
				name: 'AdvertisingRule',
				component: () => import('@/views/system/advertising-rule.vue'),
				meta: { title: '广告规则', },
			},
			{ // 广告统计
				path: 'advertising-log',
				name: 'AdvertisingLog',
				component: () => import('@/views/system/advertising-log.vue'),
				meta: { title: '广告统计', },
			},

			{ // 营销账户详情
				path: 'marketing-account-detail',
				name: 'MarketingAccount',
				component: () => import('@/views/system/marketing-account-detail.vue'),
				meta: { title: '营销账户详情', },
			},
			{ // 自燃险订单管理
				path: 'insurance-order-list',
				name: 'InsuranceOrderList',
				component: () => import('@/views/system/insurance-order-list.vue'),
				meta: { title: '自燃险订单管理', },
			},
			{ // 场地险订单管理
				path: 'venue-insurance-list',
				name: 'VenueInsuranceList',
				component: () => import('@/views/system/venue-insurance-list.vue'),
				meta: { title: '场地险订单管理', },
			},
			{ // 先充后付统计
				path: 'charge-first-stat',
				name: 'ChargeFirstStat',
				component: () => import('@/views/system/charge-first-stat.vue'),
				meta: { title: '先充后付统计', },
			},
			{ // B端权益包管理
				path: 'value-added-services-manage',
				name: 'ValueAddedServiceManage',
				component: () => import('@/views/system/value-added-services-manage.vue'),
				meta: { title: 'B端权益包管理', },
			}
		],
	},

	{ // 有序充电管理
		path: '/orderly-charging',
		component: Layout,
		meta: {
			title: '有序充电管理',
			icon: 'i-orderly_charging_management',
			roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR],
			auth: ['org-power-direct-config.list'],
		},
		children: [
			{
				path: '',
				name: 'OrderlyChargingManagement',
				redirect: '/orderly-charging/scheduling-model-monitor-list',
				meta: { hidden: true, },
			},
			{
				path: 'scheduling-model-monitor-list',
				name: 'SchedulingModelMonitorList',
				component: () => import('@/views/orderly-charging/scheduling-model-monitor-list'),
				meta: { title: '调度模型监控列表', auth: ['org-power-direct-config.list'], },
			},
			{
				path: 'scheduling-model-monitor-detail',
				name: 'SchedulingModelMonitorDeatil',
				component: () => import('@/views/orderly-charging/scheduling-model-monitor-detail'),
				meta: { hidden: true, title: '调度详情', },
			},
		],
	},

	{ // 用户管理
		path: '/user',
		component: Layout,
		meta: {
			title: '用户管理',
			icon: 'i-user_management',
			roles: [LOGIN_TYPE.ADMIN],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'UserManagement',
				redirect: '/user/user-list',
				meta: { hidden: true, },
			},
			{
				path: 'user-list',
				name: 'UserList',
				component: () => import('@/views/user/user-list'),
				meta: { title: '用户列表', roles: [LOGIN_TYPE.ADMIN] },
			},
			{
				path: 'user-detail',
				name: 'UserDetail',
				component: () => import('@/views/user/user-detail'),
				meta: { hidden: true, title: '用户详情', roles: [LOGIN_TYPE.ADMIN, LOGIN_TYPE.OPERATOR], },
			},
		],
	},
	{ // 管理员管理
		path: '/admin',
		component: Layout,
		meta: {
			title: '管理员管理',
			icon: 'i-jurisdiction_management',
			roles: [LOGIN_TYPE.ADMIN],
			is_leaf: true,
		},
		children: [
			{
				path: '',
				name: 'AdminManagement',
				redirect: '/admin/admin-list',
				meta: { hidden: true, },
			},
			{
				path: 'admin-list',
				name: 'AdminList',
				component: () => import('@/views/admin/admin-list'),
				meta: { title: '管理员列表', },
			},
			{
				path: 'admin-detail',
				name: 'AdminDetail',
				component: () => import('@/views/admin/admin-detail'),
				meta: { hidden: true, title: '管理员详情', },
			},
		],
	},
	/* { // 员工管理 hidden
		path: '/account',
		component: Layout,
		meta: {
			hidden: true,
			title: '员工管理',
			icon: 'i-user_management',
			roles: [LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				name: 'AccountManagement',
				redirect: '/account/account-list',
				meta: { hidden: true, },
			},
			{
				path: 'account-list',
				name: 'AccountList',
				component: () => import('@/views/account/account-list.vue'),
				meta: { title: '员工列表', },
			},
			{
				path: 'account-detail',
				name: 'AccountDetail',
				component: () => import('@/views/account/account-detail.vue'),
				meta: { hidden: true, title: '员工详情', },
			},
			{
				path: 'role-list',
				name: 'RoleList',
				component: () => import('@/views/account/role-list.vue'),
				meta: { title: '角色列表', },
			},
		],
	}, */
	/* { // 工人管理
		path: '/worker',
		component: Layout,
		meta: {
			hidden: true,
			title: '工人管理',
			icon: 'i-worker_management',
			roles: [LOGIN_TYPE.OPERATOR],
		},
		children: [
			{
				path: '',
				name: 'WorkerManagement',
				component: () => import('@/views/worker/worker-list'),
				meta: { title: '工人管理', },
			},
		],
	}, */
];

export default routes;
